import React from 'react';
import {styled} from "@mui/material/styles";

const TextBox = styled('div')`
  padding: 16px;
`;

export default function FileOpen() {
  return (
    <TextBox>
      Not yet implemented. This will open an existing project new project.
      <TextBox>Select Go to introduction... in to top right corner to start the introdution.</TextBox>
    </TextBox>
  );
}
